import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

const RoadClosures: React.FC = () => {
  return (
    <Container maxWidth={false} sx={{ mt: 3, mb: 3 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1, fontWeight: 600 }}>
          Road Closures
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Critical travel highlights for this weekend appear first, followed by event and facility details.
        </Typography>
      </Paper>

      <Box
        component="iframe"
        title="Toronto Road Closures Dashboard"
        src="/api/road-closures"
        sx={{
          width: '100%',
          minHeight: 'calc(100vh - 220px)',
          border: 0,
          borderRadius: 3,
          backgroundColor: '#f7f8fb',
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
        }}
      />
    </Container>
  );
};

export default RoadClosures;
